import React, { useEffect, useState } from "react";
import "tailwindcss/tailwind.css";
// import datacloud from "../../Assets/data-cloud.jpeg";
// import dynamic from "../Asse/ts/dynamic_image.jpeg";
import datacloud from "../../Assets/data-cloud.png";
import time from "../../Assets/image2.png";
import { useDispatch, useSelector } from "react-redux";
import {
  requestBackgroundImage,
  requestLoginAction,
  setResetStateLogin,
} from "../../Redux/LoginState/LoginActionCreator";
import { useNavigate } from "react-router-dom";
import ForgotPasswordForm from "./ForgotPasswordForm";
import Loader from "../../components/Loader";
import LOCAL_KEYS, { setToLocalStorage } from "../../helpers/Localstorage";
// import ResetForm from "./ResetForm";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import Uni_Logo from "../../Assets/Uni_Logo.png";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dynamicImages, setDynamicImages] = useState([time]);
  const BackgroundImageReducer = useSelector((state) => state.FileReducer);
  const { loginResponse } = useSelector((state) => state.LoginReducer);
  const ForgetPasswordState = useSelector((state) => state.ForgotPasswordReducer);

  useEffect(() => {
    if (loginResponse !== null) {
      setToLocalStorage(LOCAL_KEYS.ACCESS_TOKEN, loginResponse.access_token);
      setToLocalStorage(LOCAL_KEYS.REFRESH_TOKEN, loginResponse.refresh_token);
      setToLocalStorage(LOCAL_KEYS.USER_DETAILS, loginResponse.userDetails);
      dispatch(setResetStateLogin());
      navigate("/", { replace: true });
    }
  }, [loginResponse]);

  // useEffect(() => {
  //   dispatch(requestBackgroundImage());
  // }, []);

  // useEffect(() => {
  //   if (
  //     BackgroundImageReducer?.response &&
  //     BackgroundImageReducer?.response?.blobUrl &&
  //     !BackgroundImageReducer?.loading
  //   ) {
  //     setDynamicImages([BackgroundImageReducer?.response?.blobUrl, time]);
  //   }
  // }, [BackgroundImageReducer]);

  const settings = {
    dots: false,
    fade: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    waitForAnimate: false,
  };

  return (
    <div className="flex min-h-screen h-screen w-screen overflow-hidden bg-gray-50">
      <Loader isLoading={ForgetPasswordState?.loading} />
      {/* Left side with background image */}
      <div className="lg:hidden absolute inset-0 w-full h-full">
        <img
          className="w-full h-full object-cover"
          src={time}
          alt="Background"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-black/30 to-transparent opacity-50" />
      </div>

      {/* Right side with background image - only visible on lg screens */}
      <div className="hidden lg:flex lg:w-[70.83%] h-screen relative overflow-hidden">
        <div className="w-full h-full relative">
          <img
            className="absolute inset-0 w-full h-full object-cover"
            src={time}
            alt="Background"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent z-10" />
          <div className="absolute bottom-0 left-0 right-0 p-12 z-20">
            <h2 className="text-4xl font-medium text-gray-400 mb-4 drop-shadow-lg tracking-wide">
              Transforming Ideas into Digital Excellence
            </h2>
          </div>
        </div>
      </div>
      {/* Forgot Password form */}
      {/* <div className="w-full md:w-5/12 lg:w-3/12 flex items-center justify-center p-4 md:p-6 bg-white/90">
        <div className="w-full max-w-md min-h-[80vh] md:min-h-0 flex items-center justify-center">
          <ForgotPasswordForm />
        </div>
      </div> */}
       <div className="w-full lg:w-[29.17%] flex items-center justify-center h-screen relative z-10">
        <div className="w-full max-w-md px-4 sm:px-8 py-6 flex flex-col items-center justify-center">
          <div className="w-full flex flex-col items-center justify-center">
            <div className="w-full lg:bg-transparent backdrop-blur-md bg-white/10 rounded-2xl p-6 sm:p-8 shadow-2xl border border-white/20 lg:border-none lg:shadow-none lg:rounded-none">
            <ForgotPasswordForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
